/**
 * Formats a duration in seconds as `m:ss` (e.g. 21 → "0:21", 75 → "1:15").
 */
export function formatDuration(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
}
